export const USER_LIST = 'USER_LIST';
export const USER_PAGINATION = 'USER_PAGINATION';